import React from 'react'
import classNames from 'classnames'
import { getKey } from '@helpers/env'
import { BREAKPOINT_SIZES } from '@consts/index'
import { useMediaQuery } from '@helpers/hooks'
import styles from './styles.module.scss'

type FormHeaderProps = {
  content: {
    byline?: string[]
    title: string
    image: {
      desktop?: string
      mobile: string
    }
    itemsCountText?: string | null
  }
  classes?: string
  children?: React.ReactNode
}

export function ReturnsHeaderImage({
  content,
  classes,
  children
}: FormHeaderProps) {
  const isTabletUp = useMediaQuery({ minWidth: BREAKPOINT_SIZES.TABLET })
  const bgImage =
    isTabletUp && content?.image?.desktop
      ? content?.image?.desktop
      : content?.image?.mobile || ''
  const formHeaderStyles = classNames(styles.ReturnsHeader, classes)

  return (
    <div
      className={formHeaderStyles}
      style={{ backgroundImage: `url(${bgImage})` }}
    >
      <h1>{content.title}</h1>

      {(content.byline || []).map((copy, i) => (
        <p key={getKey(i)}>
          <span>{copy}</span>
          <span className={styles.ReturnsHeader__itemsCount}>
            {content.itemsCountText || ''}
          </span>
        </p>
      ))}
      {children}
    </div>
  )
}
